import styled from 'styled-components'

import { ClinTheme } from '../../../ClinTheme'
import {
  ClinPatientTableHeaderCell,
  ClinTableRow,
  ClinTableBodyCell,
  ClinTable
} from '../../../components/ClinTable/ClinTable'
import { ClinTableToggleRowButton } from '../../../components/ClinTableToggleRowButton'

interface ClinTableRowStyledProps {
  background?: string
  isOpen?: boolean
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

export const StyledClinPatientTableHeaderCell = styled(
  ClinPatientTableHeaderCell
)({
  cursor: 'default',
  padding: '16px 8px 8px',
  height: ClinTheme.space[7],

  '&:first-child': {
    padding: '16px 8px 8px 16px'
  },

  '&:last-child': {
    padding: '16px 16px 8px 8px',

    div: {
      justifyContent: 'flex-end'
    }
  },

  '&:nth-last-child(2)': {
    paddingRight: 0
  }
})

export const StyledClinTableRow = styled(ClinTableRow)<ClinTableRowStyledProps>`
  border: 0;
  position: relative;

  &:focus {
    background: ${ClinTheme.colors.white};
  }

  &.main-row.highlighted {
    position: relative;
    background: ${ClinTheme.colors.white};
    z-index: 2;
    border: 0;
    box-shadow: ${ClinTheme.shadows[3]};
  }

  &.main-row.expanded::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    right: 0;
    height: 5px;
    background: ${ClinTheme.colors.white};
    border-bottom: 1px solid ${ClinTheme.colors.grey};
    z-index: 3;
  }
`

export const StyledClinTableExpandedRow = styled(
  ClinTableRow
)<ClinTableRowStyledProps>`
  position: relative;
  z-index: 1;
  overflow: hidden;
  border: 0;

  &:focus {
    background: ${ClinTheme.colors.white};
  }

  &.expanded-row.highlighted {
    position: relative;
    background: ${ClinTheme.colors.white};
    z-index: 1;
    box-shadow: ${(props) => props.isOpen && ClinTheme.shadows[3]};
  }

  & > td {
    padding-top: ${(props) => (props.isOpen ? '11px' : '0!important')};
    padding-bottom: ${(props) => (props.isOpen ? '11px' : '0!important')};
    transition: padding 0.6s;

    & > div {
      max-height: ${(props) => (props.isOpen ? '' : '0')};
      opacity: ${(props) => (props.isOpen ? 1 : 0)};
      overflow: hidden;
      transform: scaleY(${(props) => (props.isOpen ? 1 : 0)});
      transform-origin: top;
      transition: ${(props) =>
        props.isOpen
          ? 'max-height 0.6s ease, opacity 0.6s ease, transform 0.6s ease'
          : 'max-height 0.3s ease, opacity 0.3s ease, transform 0.3s ease'};
    }
  }
`

export const StyledProductInformationBox = styled.div`
  display: flex;
  justify-content: space-between;
`

export const ProductInformationBox = styled.div`
  width: 100%;
`

export const StyledClinTableBodyCell = styled(ClinTableBodyCell)<{
  rowExpanded?: boolean
}>(({ rowExpanded }) => ({
  padding: rowExpanded ? '8px 8px 4px' : '8px',
  '&:first-child': {
    paddingLeft: '16px'
  },

  '&:last-child': {
    paddingRight: '16px',
    textAlign: 'right',

    'button.icon-toggle': {
      margin: '4px',
      color: ClinTheme.colors.primaryMid,

      '&:hover svg path:first-child': {
        fill: ClinTheme.colors.primaryMid
      },

      '&:focus': {
        boxShadow: 'none'
      },

      '&:hover': {
        boxShadow: 'rgb(231, 232, 232) 0px 0px 0px 2px'
      }
    }
  }
}))
export const StyledClinTable = styled(ClinTable)<{ width?: string }>`
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
  overflow: visible;
`
export const FixedWidthCell = styled.div<{
  width?: string
  minWidth?: string
  maxWidth?: string
}>`
  width: ${(props) => props.width};
  min-width: ${(props) => props.minWidth};
  max-width: ${(props) => props.maxWidth};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StyledStatusCell = styled.div({
  '& > div': {
    width: 'auto'
  },
  '.clin-text': {
    fontSize: ClinTheme.fontSizes[0]
  }
})

export const StyledStatusCellSpinner = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 26,
  padding: `${ClinTheme.space[1]}px ${ClinTheme.space[2]}px`,
  boxSizing: 'border-box'
})

export const StyledDesktopWrapper = styled.div({
  width: '100%',
  overflowX: 'auto',
  overflow: 'visible',
  display: 'block'
})

export const StyledClinTableToggleRowButton = styled(ClinTableToggleRowButton)({
  margin: '4px'
})

export const StyledStrengthCell = styled('div')({
  marginTop: '6px',

  '&:first-child': {
    marginTop: 0
  }
})
